export default "__VITE_ASSET__SGVgWO7H__"